import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IStudentExamVm } from '../student-exam-vm.model';
import { IPaginatedResultStudentExamVm } from '../paginated-result-student-exam-vm.model';
import { InternalExamSource } from '../internal-exam-classification.model';
@Injectable({ providedIn: 'root' })
export class MyOskStudentsExamsService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MyOskStudentsExams`;
  }
  get(
    search?: string,
    page?: number,
    pageSize?: number,
    source?: InternalExamSource
  ): Observable<IPaginatedResultStudentExamVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (search !== undefined && search !== null) {
      params = params.set('search', search.toString());
    }
    if (page !== undefined && page !== null) {
      params = params.set('page', page.toString());
    }
    if (pageSize !== undefined && pageSize !== null) {
      params = params.set('pageSize', pageSize.toString());
    }
    if (source !== undefined && source !== null) {
      params = params.set('source', source.toString());
    }
    return this.http.get<IPaginatedResultStudentExamVm>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
